function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

var ProgressThermometer = function ProgressThermometer(_ref) {
  var _ref$totalSteps = _ref.totalSteps,
      totalSteps = _ref$totalSteps === void 0 ? 0 : _ref$totalSteps,
      _ref$currentStep = _ref.currentStep,
      currentStep = _ref$currentStep === void 0 ? 0 : _ref$currentStep;
  var stepArray = Array.from({
    length: totalSteps
  }, function (v, i) {
    return i + 1;
  });
  var ariaLabel = "Progress thermometer chart showing ".concat(totalSteps, " items, with item ").concat(currentStep, " highlighted");

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  useEffect(function () {
    var percentWidth = (currentStep - 1) / (totalSteps - 1) * 100;
    if (percentWidth < 0) setWidth(0);else if (percentWidth > 100) setWidth(100);else setWidth(percentWidth);
  }, [totalSteps, currentStep]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: "et-progress-thermometer",
    "aria-label": ariaLabel
  }, stepArray.map(function (step) {
    return /*#__PURE__*/React.createElement("li", {
      key: step,
      "aria-label": "progress point"
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("et-progress-thermometer--remaining-step", {
        "et-progress-thermometer--active-step": step === currentStep
      }, {
        "et-progress-thermometer--completed-step": step < currentStep
      })
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "et-progress-thermometer--line--outer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "et-progress-thermometer--line--inner",
    style: {
      width: width + "%"
    }
  })));
};

ProgressThermometer.propTypes = {
  totalSteps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired
};
export default ProgressThermometer;